const isIE11: boolean = !!(<any>window).MSInputMethodContext && !!(<any>document).documentMode
const isIE10: boolean = navigator.appVersion.indexOf('MSIE 10') !== -1

export const userAgentIsInternetExplorer = (): boolean => isIE10 || isIE11
